/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { parse } from 'query-string'
import { Navigate, useLocation } from 'react-router-dom'

import type { FunctionComponent } from 'react'

const MarketplaceRegistrationRedirect: FunctionComponent = () => {
  const location = useLocation()
  const query = parse(location.search.slice(1))
  const token = String(query.token)

  return (
    <Navigate
      to={{
        pathname: '/marketplace-registration',
        search: `?source=partners&partner=gcp&redirectTo=%2Fmarketplace-conversion%23token%3D${token}%26partner%3Dgcp`,
      }}
    />
  )
}

export default MarketplaceRegistrationRedirect
